import {AuthState, BranchesMap} from './Types'
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import User from "../../Models/User";
import {arrayToOptions} from "../../Utils/Utils";

const token = localStorage.getItem('token');

const initialState: AuthState = {
  state: 'idle',
  user: {} as User,
  logged: !!token,
  branches: [],
  currentBranch: {name: '', _KEY: '', city: '', version: 0},
  token
};

const Auth = createSlice({
  name: 'Auth',
  initialState,
  reducers: {
    getLogin(state, action) {
      state.state = "pending";
    },
    logout(state) {
      state.logged = false;
      state.token = null;
      state.branches = [];
      state.user = {} as User;
      state.currentBranch = initialState.currentBranch;
    },
    setLogin(state, action: PayloadAction<any>) {
      state.state = 'idle';
      state.logged = true;
      state.token = action.payload.token;
      state.user = action.payload.user;
      state.currentBranch = action.payload.currentBranch;
      state.branches = action.payload.branches;
      state.branchOptions = arrayToOptions(state.branches, "_KEY", "label");
      state.branchesMap = state.branches.reduce((acc: BranchesMap, item) => {
        acc[item._KEY] = item;
        return acc;
      }, {});
    },
    setLoginError(state) {
      state.state = 'idle';
    },
    getCurrentUser(state) {},
    setUser(state, { payload }: PayloadAction<any>) {
      state.user = payload.user
    },
    forgotPassword(state, {payload}:PayloadAction<any>){},
    recoverPassword(state, { payload }: PayloadAction<any>) {},
    changePassword(state,{payload}:PayloadAction<any>){}
  }
});

export const AuthActions = Auth.actions;

export default Auth.reducer;
